/* Small editorial figure with mask-reveal + universal parallax + reveal-scale.
   The `.parallax-inner` wrapper takes the scroll transform so it never
   fights the mask-reveal on the <img>. The `.reveal-scale` <span>
   carries the entry animation (fade + scale 0.96→1 + rise 16px + slide
   ±8px + blur 6→0) and the hover scale, so the KB transform on the img
   is fully isolated. */
const hashSlide = (src) => {
  let h = 5381;
  for (let i = 0; i < src.length; i++) h = ((h * 33) ^ src.charCodeAt(i)) >>> 0;
  return h % 2 === 0 ? "8px" : "-8px";
};

export const EditorialFigure = ({
  src,
  alt,
  height = "h-[42vh] min-h-[280px] max-h-[560px]",
  testId,
  rule = true,
  priority = false,
}) => (
  <figure className="reveal mask-reveal" data-testid={testId}>
    <div className={`relative w-full ${height} overflow-hidden`}>
      <div className="absolute inset-0 parallax-inner">
        <span
          className="reveal-scale"
          style={{ "--rv-x": hashSlide(src) }}
        >
          <img
            src={src}
            alt={alt}
            loading={priority ? "eager" : "lazy"}
            className="absolute inset-0 h-full w-full object-cover"
          />
        </span>
      </div>
    </div>
    {rule && <div className="rule-gold w-16 mt-8" aria-hidden />}
  </figure>
);

export default EditorialFigure;
